module.exports = __webpack_public_path__ + "static/media/mainimg-05.2e041285.png";